export default function searchRouteQuery(parameters, overrides = {}) {
  return {
    q: encodeURI(parameters.q || ''),
    semantic: parameters.isSemanticSearch,
    exactPhrase: parameters.isfullTextQuery,
    hybrid: parameters.useVectorSearch,
    ...overrides,
  };
}

export function sameSearchRouteQuery(first, second) {
  const normalize = (query) => Object.keys(query).sort()
    .filter((key) => query[key] != null)
    .map((key) => [key, String(query[key])]);
  return JSON.stringify(normalize(first)) === JSON.stringify(normalize(second));
}
